module.exports = __webpack_public_path__ + "img/常见问题.3b402723.png";